import {Box, IconButton, List, ListItem, ListItemButton, ListItemText, Toolbar, Typography} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, {useContext, useState} from "react";
import {Add, Delete} from "@mui/icons-material";
import {FirebaseContext} from "../../firebase/FirebaseProvider";
import {connect} from "react-redux";
import {selectProject} from "../../../redux/selectors/editor";
import {selectShortcuts} from "../../../redux/selectors/firebase";
import {ShortcutDialog} from "./ShortcutDialog";

const useStyles = makeStyles((theme) => ({
    toolbar: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.background.paper,
        marginTop: theme.spacing(1),
        minHeight: 0,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
}));

export interface IShortcut {
    action: {
        type: string
        data: any
    }
    event: {
        key: string
        ctrlKey: boolean
        shiftKey: boolean
        altKey: boolean
    }
    name: string
    identifier: string
}
interface IShortcuts {
    project: string
    shortcuts: {[key: string]: IShortcut}
}
function Shortcuts({project, shortcuts}: IShortcuts) {
    const classes = useStyles();
    const {push, remove} = useContext(FirebaseContext);
    const [edit, setEdit] = useState("");
    const handleAddShortcut = () => {
        push(`shortcuts/${project}`, {name: "New Shortcut"}).catch(console.error)
    };
    const handleDeleteShortcut = (key: string) => () => {
        remove(`shortcuts/${project}/${key}`).catch(console.error);
    };
    const handleEditShortcut = (key: string) => () => {
        setEdit(key);
    };

    return (
        <Box>
            <ShortcutDialog onClose={() => setEdit("")} edit={edit} project={project} shortcuts={shortcuts}/>
            <Toolbar classes={{dense: classes.toolbar}} disableGutters variant="dense">
                <Typography flexGrow={1} variant="h6">Shortcuts</Typography>
                <IconButton color="inherit" edge="end" onClick={handleAddShortcut} size="small"
                            title="Add shortcut">
                    {<Add/>}
                </IconButton>
            </Toolbar>
            <List>
                {Object.entries(shortcuts).map(([key, shortcut]) =>
                    <ListItem disablePadding key={key} secondaryAction={
                        <IconButton onClick={handleDeleteShortcut(key)}>
                            <Delete/>
                        </IconButton>
                    }>
                        <ListItemButton onClick={handleEditShortcut(key)}>
                            <ListItemText primary={shortcut.name} secondary={shortcut.identifier}/>
                        </ListItemButton>
                    </ListItem>
                )}
            </List>
        </Box>
    );
}
const mapStateToProps = (store: never) => ({
    project: selectProject(store),
    shortcuts: selectShortcuts(store) || {}
});

const connected = connect(mapStateToProps, {
})(Shortcuts);
export {connected as Shortcuts}